document.addEventListener('DOMContentLoaded', function () {
    // Get all banners outside of the function to avoid re-querying each time
    const banners = document.querySelectorAll('.block-banner');
    
    // If no banners are found, terminate early
    if (banners.length === 0) return;

    // Function to adjust the layout based on the screen width
    function adjustBannerLayout() {
        banners.forEach(function (banner) {
            // Find the necessary elements
            const content = banner.querySelector('.block-banner__content');
            const imageSpan = banner.querySelector('.component-picture');
            const image = imageSpan ? imageSpan.querySelector('img') : null;

            // If there's no image or content, skip the iteration
            if (!image || !content) return;

            // Get the distance from the edge of the screen to the content container
            const contentRect = content.getBoundingClientRect();
            const contentLeft = contentRect.left;  // Distance from the left edge of the screen
            const contentRight = contentRect.right; // Distance from the right edge of the screen

            // Calculate the distance to the edge
            const screenLeft = contentLeft < 0 ? 0 : contentLeft; // Avoid negative distance
            const screenRight = window.innerWidth - contentRight < 0 ? 0 : window.innerWidth - contentRight;

            // Get the alignment of the image (you may have a class or field for this)
            const mediaAlignment = banner.querySelector('.block-banner__content').dataset.mediaAlignment;

            // Check alignment and adjust image and margin
            if (mediaAlignment === 'right') {
                // Add space to the image width for right alignment
                imageSpan.style.width = `calc(100% + ${screenRight}px)`;
                imageSpan.style.marginRight = `${screenRight}px`;
                imageSpan.style.marginLeft = '0'; // Remove any left margin
            } else if (mediaAlignment === 'left') {
                // Add space and negative margin for left alignment
                imageSpan.style.width = `calc(100% + ${screenLeft}px)`;
                imageSpan.style.marginLeft = `-${screenLeft}px`;
                imageSpan.style.marginRight = '0'; // Remove any right margin
            }
        });
    }

    // Initial call to adjust layout when the page loads
    adjustBannerLayout();

    // Call adjustBannerLayout on window resize
    window.addEventListener('resize', adjustBannerLayout);
});